import { render, staticRenderFns } from "./lateral.vue?vue&type=template&id=4def45a7&scoped=true"
import script from "./lateral.vue?vue&type=script&lang=js"
export * from "./lateral.vue?vue&type=script&lang=js"
import style0 from "./lateral.vue?vue&type=style&index=0&id=4def45a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4def45a7",
  null
  
)

export default component.exports